// MTVW-918
import { useEffect, useState } from 'react'
import { debounce } from "lodash"

export const useMediaQuery = (query) => {
	const mediaMatch = window.matchMedia(query)
	const [matches, setMatches] = useState(mediaMatch.matches)

	const handleResize = (e) => {
		//console.debug("useMediaQuery", mediaMatch.matches, e)
		setMatches(mediaMatch.matches)
	}

	useEffect(() => {
		//mediaMatch.addListener(handler)
		//window.mediaMatch("resize", handleResize)
		window.addEventListener("resize", debounce(handleResize, 200))
		//return () => mediaMatch.removeListener(handler)
		//return () => mediaMatch.removeEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", debounce(handleResize, 200))
	}, [])
	return matches
}

